<script lang="ts">
  import { run } from 'svelte/internal';

  import { derived } from 'svelte/store';

  import { runs } from '../../shared/stores/run-data-store';
  import { msToTime } from '../../shared/utils';

  const totals = derived(runs, ($runs) => {
    const nRuns = $runs.length;
    const _totals = $runs.reduce(
      (prev, curr) => {
        return {
          distance: prev.distance + curr.data.distance,
          totalTime: prev.totalTime + curr.data.totalTime,
        };
      },
      {
        distance: 0,
        totalTime: 0,
      }
    );
    _totals.runs = nRuns;
    return _totals;
  });
</script>

<div class="total">
  <div class="total__header">Runs</div>
  <h3 class="total__value">{$totals.runs}</h3>
</div>

<div class="total">
  <div class="total__header">Miles</div>
  <h3 class="total__value">{$totals.distance.toFixed(2)}</h3>
</div>

<div class="total">
  <div class="total__header">Time</div>
  <h3 class="total__value">{msToTime($totals.totalTime)}</h3>
</div>

<style lang="scss">
  .total {
    display: inline-block;
    margin: 8px;

    &__header {
      color: #757575;
    }

    &__value {
      font-size: 32px;
      font-weight: bold;
      color: #b155bd; // TODO: get from theme
      margin: 0;
    }
  }
</style>
